/**********************************************************************************************************************/
/* FILE: hafas_webapp_subscription_timetable.js                                                                       */
/**********************************************************************************************************************/
/* Subscriptions Timetable */
HafasWebapp.prototype.subscriptions.Timetable = function (_me) {

  // History Back
  Hafas.ps.sub('/GUI/closeView/Timetable', Hafas.bind(_me.Controller.Timetable.closeView,_me));
  Hafas.ps.sub('/GUI/restoreView/Timetable', Hafas.bind(_me.Controller.Timetable.restoreView,_me));
  Hafas.ps.sub('/GUI/leaveContext/Timetable', Hafas.bind(_me.Controller.Timetable.cleanup,_me));

  // Initialisiere Haltestellen-Formular
  // Initialisiere Linien-Formular
  Hafas.ps.sub('/timetable/initForm/stop', Hafas.bind(function() {
     Hafas.bind(_me.Controller.Timetable.cleanup, _me)();
    this.Controller.Timetable.selectedInput = "stop";
    Hafas.bind(_me.Controller.Timetable.initStopForm, _me)();
  },_me));

  // Initialisiere Linien-Formular
  Hafas.ps.sub('/timetable/initForm/line', Hafas.bind(function() {
     Hafas.bind(_me.Controller.Timetable.cleanup, _me)();
    this.Controller.Timetable.selectedInput = "line";
    Hafas.bind(_me.Controller.Timetable.initLineForm, _me)();
  },_me));

  Hafas.ps.sub('/timetable/set/stops', Hafas.bind(_me.Controller.Timetable.setSelectedDirectionStops,_me));

  // Timetable-Feature aus dem Timetable-Formular triggern
  Hafas.ps.sub('/timetable/search', Hafas.bind(function() {
/*    var data = {
      lineId: _me.Controller.Timetable.instance.getLineId(),
      callback: Hafas.bind(_me.Controller.Timetable.showResultOverview, _me)
    };
    _me.Controller.Timetable.instance.searchLineDetails(data);*/
    Hafas.bind(_me.Controller.Timetable.showResultOverview, _me)();
  },_me));

  //** jumpin-Funktion in das Timetable-Feature aus einem anderen Context
  Hafas.ps.sub('/timetable/linesearch/jumpin', Hafas.bind(function(params) {

    // vorherigen Kontext verlassen (vor allem, um alte Karteninhalte zu löschen)
    Hafas.ps.pub('/GUI/leaveContext/' + params.appContext);

    _me.appContext = "Timetable";
    if(params.hasOwnProperty('lineId')) {
      _me.Controller.Timetable.instance.setLineId(params.lineId);
    }
    if(params.hasOwnProperty('dirText')) {
      Hafas.bind(_me.Controller.Timetable.setDirectionText, _me)(params.dirText);
      _me.Controller.Timetable.instance.setDirection(params.dirText);
    }
    // set destination location (optional)
    if(params.hasOwnProperty('location')) {
      params.location.type = "S";
      _me.Controller.Timetable.instance.setLocation(params.location);
    }
    var data = {
      lineId: _me.Controller.Timetable.instance.getLineId(),
      callback: function(result) {
        Hafas.bind(_me.Controller.Timetable.setLineDetailsResult, _me)(result[0]);
        Hafas.bind(_me.Controller.Timetable.showResultOverview, _me)();
      }
    };
    if(_me.Controller.Timetable.instance.getLocation('S').hasOwnProperty('lid')) {
      data.stop = _me.Controller.Timetable.instance.getLocation('S');
    }

    _me.Controller.Timetable.instance.searchLineDetails(data);

  },_me));

  // Ergebnisse aus dem Zuglauf verwenden, um Zielhaltestelle für Timetable zu ermitteln (solange das nicht über ein Direction-Flag geht)
/*  Hafas.ps.sub('/trainroute/results', Hafas.bind(function(result) {
    console.log("set loc /trainroute/results");
    var locationDest = result.stopL[result.stopL.length - 1].locResolved;
    locationDest.type = "Z";
    _me.Controller.Timetable.instance.setLocation(locationDest);
  },_me));*/

  // Ergebnisse aus der Liniensuche verwenden, um Zielhaltestelle für Timetable zu ermitteln (solange das nicht über ein Direction-Flag geht)
  Hafas.ps.sub('/linesearch/results', Hafas.bind(function(result) {
    var locationDest = result.stopList[result.stopList.length - 1].location;
    locationDest.type = "Z";
    _me.Controller.Timetable.instance.setLocation(locationDest);
  },_me));

  //** Auswahl einer Haltestelle, auf deren Grundlage die Tabelle angefragt wird
  Hafas.ps.sub('/timetable/location/input', Hafas.bind(function(trigger, type) {
    // console.log("+++ /timetable/location/input +++");
    var me = this;
    var lid = "";
    var name = "";
    var extId = "";
    var selectedOption = trigger.options[trigger.selectedIndex];
    if(selectedOption.getAttribute("data-loc-option") != null) {
      lid = selectedOption.getAttribute("data-loc-option");
      name = selectedOption.getAttribute("data-loc-name");
      extId = selectedOption.getAttribute("data-loc-extId");
    }
    Hafas.ps.pub('/timetable/result/load', [{location: {lid: lid, name: name, type: type, extId: extId} }]);
  },_me));

  //** Rendern einer neuen Tabelle triggern
  Hafas.ps.sub('/timetable/result/load', Hafas.bind(function(params) {
    // set destination location (optional)
    Hafas.Util.gui.setVisibility(Hafas("[data-result-container='timetable']"), true);
    if(Hafas.Config.Timetable.showNextDepartures) {
      Hafas.Util.gui.setVisibility(Hafas("[data-timetable-container='departure_wrapper']"), true);
    }
    if(params.location) {
      // params.location.type = "S";
      _me.Controller.Timetable.instance.setLocation(params.location);
    }

    if(params.hasOwnProperty('lineId')) {
      Hafas.ps.pub('/timetable/setLineId', [params.lineId]);
    } else {
      params.lineId = _me.Controller.Timetable.instance.getLineId();
    }
    Hafas.ps.pub('/gui/common/showLoader', [true]);
    params.callback = function(res) {
      // Hafas.ps.pub('/timetable/searchLineDetails')
      Hafas.bind(_me.Controller.Timetable.renderTimetableTable, _me)(res);
    };
    _me.Controller.Timetable.instance.searchSchedules(params);

  },_me));

  // Liniennummer an das Timetable-Modul übergeben, um per LineMatch-Request danach zu suchen
  Hafas.ps.sub('/timetable/setLine', Hafas.bind(function(line) {
    _me.Controller.Timetable.instance.setLineMatchResult(line);
  },_me));

  // Linien-Id an das Timetable-Modul übergeben, um per LineDetails-Request danach zu suchen
  Hafas.ps.sub('/timetable/setLineId', Hafas.bind(function(lineId) {
    _me.Controller.Timetable.instance.setLineId(lineId);
  },_me));

  // Location-Id an das Timetable-Modul übergeben
  Hafas.ps.sub('/timetable/setLocation', Hafas.bind(function(params) {
    _me.Controller.Timetable.instance.setLocation(params);
  },_me));

/*  Hafas.ps.sub('/app/events/resize', Hafas.bind(function() {
    Hafas.bind(_me.Controller.Timetable.buildTimetables, _me)();
  },_me));*/

  // Save a current journey
  Hafas.ps.sub('/common/result/journey', Hafas.bind(function(journey) {
    _me.Controller.Timetable.currentJourney = journey;
  },_me));

  Hafas.ps.sub('/sq/dataChanged/webapp', Hafas.bind(function() {
    // debugger;
    if(Hafas.Config.Timetable.showNextDepartures && (this.appContext == "Timetable")) {
      Hafas.bind(_me.Controller.Timetable.showNextDepartures, _me)();
    }
  },_me));

  Hafas.ps.sub('/tq/showTrainroute', Hafas.bind(function(params) {
    var currentLocation =_me.Controller.SQ.instance.getLocation();
    if(currentLocation.hasOwnProperty('name') && currentLocation.hasOwnProperty('lid')) {
      var model = {
        lid: currentLocation.lid,
        name: currentLocation.name,
        type: "S"
      };
      _me.Controller.Timetable.instance.setLocation(model);
      // Hafas.ps.pub('/timetable/result/load', [{location: model}]);
    }
  },_me));

  Hafas.ps.sub('/timetable/selectStation', Hafas.bind(_me.Controller.Timetable.selectStation,_me));

  Hafas.ps.sub('/timetable/deleteStation', Hafas.bind(_me.Controller.Timetable.deleteStopInput,_me));

  Hafas.ps.sub('/timetable/deleteLine', Hafas.bind(_me.Controller.Timetable.deleteLineInput,_me));

  Hafas.ps.sub('/timetable/set/direction', Hafas.bind(_me.Controller.Timetable.setDirectionText,_me));

  Hafas.ps.sub('/timetable/jumpin', Hafas.bind(_me.Controller.Timetable.jumpinTimetable,_me));

  Hafas.ps.sub("/suggest/selectitem/TimetableStopInput", Hafas.bind(function(hfsLocObj, instance, isValidation) {
    if(hfsLocObj.name) {
      Hafas('#TimetableStopInput').value = hfsLocObj.name;
    }
    if(Hafas.Config.Favorites.addLocationOnSuggest) {
      Hafas.bind(_me.Controller.Timetable.addLocationToHistory, _me)({location: hfsLocObj});
    }
    Hafas.bind(_me.Controller.Timetable.processStopInput, _me)({loc: hfsLocObj, productRefList: instance.productRefList || null});
  },_me));

  Hafas.ps.sub('/timetable/addLineToFav', Hafas.bind(_me.Controller.Timetable.saveLineAsFavorite, _me));
  Hafas.ps.sub('/timetable/removeLineFromFav', Hafas.bind(_me.Controller.Timetable.deleteLineFromFavorite, _me));

  // ************ GUI **************** //
  // Container anzeigen und ausblenden
  Hafas.ps.sub('/gui/common/showTarget', Hafas.bind(_me.Controller.Timetable.GUI.common.showTarget,_me));
  // Loader anzeigen und ausblenden
  Hafas.ps.sub('/gui/common/showLoader', Hafas.bind(_me.Controller.Timetable.GUI.common.showLoader,_me));
  // ein beliebiges Element aktiv schalten und alle anderen einer Klasse inaktiv schalten
  Hafas.ps.sub('/gui/common/toggleElementClass', Hafas.bind(_me.Controller.Timetable.GUI.common.toggleElementClass,_me));

  Hafas.ps.sub('/gui/form/toggle/loading', Hafas.bind(_me.Controller.Timetable.GUI.form.toggleLoadingView,_me));

};
